export var ActivitySearchTimeType;
(function (ActivitySearchTimeType) {
    ActivitySearchTimeType[ActivitySearchTimeType["APPLIED_TIME"] = 1] = "APPLIED_TIME";
    ActivitySearchTimeType[ActivitySearchTimeType["UPDATED_TIME"] = 2] = "UPDATED_TIME";
})(ActivitySearchTimeType || (ActivitySearchTimeType = {}));
//# sourceMappingURL=ActivitySearchTimeType.js.map